import styled, { keyframes } from 'styled-components'

import { Button } from 'components/Button'
import { Container } from 'components/Container'
import { SvgImage } from 'components/SvgImage'

import { Color } from 'root-constants'

const spinKeyframes = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const StyledDownloadWellness = {
  Wrapper: styled.div`
    flex: 1;
    min-width: 100%;
    min-height: 0;
  `,
  Content: styled(Container)`
    display: flex;
    flex-direction: column;
    max-width: 375px;
    padding: 16px 24px 0;
    margin: 0 auto;
  `,
  Title: styled.p`
    font-size: 24px;
    font-weight: 700;
    line-height: 32px;
    text-align: center;
    color: ${Color.INK_DARKEST};
    margin-bottom: 24px;
  `,
  DownloadList: styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;
  `,
  DownloadCard: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background: ${Color.WHITE};
  `,
  CoverImage: styled.img`
    width: 56px;
    height: 70px;
    flex-shrink: 0;
    border-radius: 8px;
    object-fit: cover;
  `,
  CardInfo: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 4px;
  `,
  BonusLabel: styled.p`
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    font-weight: 700;
    line-height: 14px;
    letter-spacing: 0.5px;
    text-transform: uppercase;
    color: ${Color.GOLD_BASE};
  `,
  BonusLabelBullet: styled(SvgImage)`
    flex-shrink: 0;
  `,
  CardTitle: styled.p`
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    color: ${Color.INK_DARKEST};
  `,
  DownloadStatus: styled.p`
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
    color: ${Color.INK_LIGHT};
  `,
  DownloadFileButton: styled.button`
    flex-shrink: 0;
    display: flex;
    padding: 0;
    border: none;
    background: transparent;
    cursor: pointer;

    &:disabled {
      cursor: default;
    }
  `,
  DownloadSpinner: styled.div`
    width: 40px;
    height: 40px;
    border: 3px solid ${Color.GOLD_LIGHTEST};
    border-top-color: ${Color.GOLD_BASE};
    border-radius: 50%;
    animation: ${spinKeyframes} 1s linear infinite;
  `,
  DownloadIcon: styled(SvgImage)`
    flex-shrink: 0;
  `,
  ButtonsContainer: styled.div`
    position: sticky;
    bottom: 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
  `,
  DownloadAllButton: styled.button`
    width: 100%;
    height: 48px;
    margin-top: 24px;
    padding: 0 32px;
    border: 1px solid ${Color.GOLD_BASE};
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.25);
    -webkit-backdrop-filter: blur(8px);
    backdrop-filter: blur(8px);
    cursor: pointer;
    font-size: 16px;
    font-weight: 600;
    line-height: 24px;
    color: ${Color.GOLD_BASE};

    &:disabled {
      cursor: default;
      opacity: 0.6;
    }
  `,
  ContinueButton: styled(Button)`
    width: 100%;
    max-width: 100%;
    height: 48px;

    font-size: 16px;
    font-weight: 500;
    line-height: 16px;
    white-space: nowrap;
    background-color: ${Color.INK_DARKEST};
    color: ${Color.GOLD_LIGHTER};

    transition: background-color 0.2s ease-out;

    padding: 16px 32px;
    margin: 24px 0 32px;
  `,
}
